// extracted by mini-css-extract-plugin
module.exports = {"formFooter":"I3IPb7YJAxHr1+ZO1CVQ4Q==","nextButton":"UnSBq-OXWRsnoF3U8T3brQ==","editButton":"+bzYl6WnfGtqI7hLd9TlHA==","reviewButton":"zmblj6BnzHPMUQ8eeOjuJA=="};